import styled from "styled-components";

export const MobileHeaderWrapper = styled.div`
  width: 100%;
  background: #000;
  padding: 20px;
  flex-shrink: 0;
`;

export const MobileHeaderLogoWrapper = styled.div`
  width: 150px;
`;

export const MobilePageWrapper = styled.div`
  max-width: 500px;
  background: #fff;
  min-height: 100dvh;
  max-height: 100dvh;
  display: flex;
  flex-direction: column;
  margin: 0 auto;
  overflow: hidden;
`;
